"use client";
import { Fragment, ReactNode } from "react";
import { Menu, Transition } from "~/app/components/headlessui";

import { cx } from "~/panda/css";
import { SessionAvatarAndNameUseClient } from "../session/session-avatar-and-name-use-client";
import { signOut } from "../session/actions";

export const userNavigation = [
  { name: "Your profile", href: "/me" },
  { name: "Sign out", href: "/components/tailwind" },
];

export function ProfileMenuUseClient({
  // TODO: interesting pattern but let's not grow our imports
  button: buttonSlot = <SessionAvatarAndNameUseClient />,
}: {
  button?: ReactNode;
}) {
  return (
    <Menu as="div" className="relative">
      <Menu.Button className="-m-1.5 flex items-center p-1.5">
        <span className="sr-only">Open user menu</span>
        {buttonSlot}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
          <Menu.Item>
            {({ active }) => (
              <a
                href="/me"
                className={cx(
                  active ? "bg-gray-50" : "",
                  "block px-3 py-1 text-sm leading-6 text-gray-900",
                )}
              >
                Profile
              </a>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <form action={signOut}>
                <button
                  type="submit"
                  className={cx(
                    active ? "bg-gray-50" : "",
                    "min-w-full text-left block px-3 py-1 text-sm leading-6 text-gray-900",
                  )}
                >
                  Sign Out
                </button>
              </form>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
